import { render, staticRenderFns, recyclableRender, components } from "./productCity.vue?vue&type=template&id=628762f4&"
var renderjs
import script from "./productCity.vue?vue&type=script&lang=js&"
export * from "./productCity.vue?vue&type=script&lang=js&"
import style0 from "./productCity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/diy/product/productCity.vue"
export default component.exports